// extracted by mini-css-extract-plugin
module.exports = {"container":"UGCHighlightModal_container__DdthK","header":"UGCHighlightModal_header__rTR_V","imageWrapper":"UGCHighlightModal_imageWrapper__Idk_F"};